module.exports = __webpack_public_path__ + "static/media/generation.559ec832.svg";